<template lang="pug">
  #authentication
    autocomplete(
      ref="departmentSearch"
      item-value="num_dep"
      item-text="dep_name"
      placeholder="Département"
      :searchFunction="departmentSearch"
      :debounce="false"
      @select="selectDepartment"
    )
      template(v-slot:option="{ item }") {{ item.dep_name }} ({{ item.num_dep }})
    autocomplete(
      ref="dmoSearch"
      item-value="id"
      item-text="name"
      placeholder="DMO"
      :searchFunction="dmoSearch"
      @select="selectDmo"
    )
    autocomplete(
      ref="proSearch"
      item-value="id"
      item-text="name"
      placeholder="Pro"
      :searchFunction="proSearch"
      @select="selectPro"
    )
    button(
      :disabled="!(selected && type)"
      @click="authenticate"
    ) Authentifier
</template>

<script>
import Autocomplete from '@/components/RcAutocomplete.vue';
import departments from '@/ressources/departments.js';
import authService from '@/services/auth.js';

export default {
  components: {
    Autocomplete,
  },
  data() {
    return {
      departmentSearch: search => {
        return departments.filter(dep => 
          dep.dep_name.toLowerCase().includes(search.toLowerCase()) ||
          dep.region_name.toLowerCase().includes(search.toLowerCase()) ||
          (dep.num_dep + '').includes(search)
        );
      },
      dmoSearch: async search => await authService.searchDmo(search),
      proSearch: async search => await authService.searchPro(search),
      selected: null,
      type: null,
    }
  },
  methods: {
    selectDepartment(value) {
      this.$refs.dmoSearch.reset();
      this.$refs.proSearch.reset();
      this.selected = value ? value.num_dep : null;
      if (value) {
        this.type = 'department';
      }
    },
    selectErp(value) {
      this.selected = value ? value.id : null;
      if (value) {
        this.type = 'erp';
      }
    },
    selectDmo(value) {
      this.$refs.departmentSearch.reset();
      this.$refs.proSearch.reset();
      this.selectErp(value);
    },
    selectPro(value) {
      this.$refs.departmentSearch.reset();
      this.$refs.dmoSearch.reset();
      this.selectErp(value);
    },
    async authenticate() {
      const type = this.type === 'department' ? 'dep' : 'erp';
      const query = `${type}-${this.selected}`
      const token = await authService.authenticate(query);
      localStorage.setItem('authToken', token);
      this.$router.push({ name: 'Establishments' });
    },
  },
}
</script>

<style lang="scss">
  #authentication {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100vh;
    .rc-autocomplete {
      margin: 1em 0;
    }
    button {
      margin: 2em 0 1em 0;
    }
  }
</style>